import React from 'react';
import PropTypes from 'prop-types';
import ReactAudioPlayer from 'react-audio-player';

class Player extends React.Component {
  render() {
    return (
      <div>
        { this.props.state.track && this.props.src && (
          <ReactAudioPlayer
            src={this.props.src}
            ref={(element) => { this.rap = element; }}
            controls={false}
            listenInterval={500}
            onLoadedMetadata={(e) => this.props.onLoadedMetadata(e)}
            onPlay={(e) => this.props.onPlay(e)}
            onListen={(e, d) => this.props.onListen(e,d)}
            onEnded={(e) => this.props.onEnded(e)}
          />
        ) }
      </div>
    );
  }
}

Player.propTypes = {
  state: PropTypes.object.isRequired,
  // Resolved by the playlist: the standard or the premium URL of the current
  // track, depending on the selected voice.
  src: PropTypes.string,
  onLoadedMetadata: PropTypes.func,
  onPlay: PropTypes.func,
  onListen: PropTypes.func,
  onEnded: PropTypes.func
};

Player.defaultProps = {
  onLoadedMetadata: () => {},
  onPlay: () => {},
  onListen: () => {},
  onEnded: () => {}
};

export default Player;
